module.exports = __webpack_public_path__ + "static/img/about17.fc06d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about17.png
// module id = e3cD
// module chunks = 1